export const NAME = 'configuration';

const CONTEXT = 'CONFIGURATION';

const RESET = `${CONTEXT}::RESET`;

const CHANGE = `${CONTEXT}::CHANGE`;
const MOUNT = `${CONTEXT}::MOUNT`;
const UNMOUNT = `${CONTEXT}::UNMOUNT`;

export const ACTION_TYPES = {
  RESET,
  CHANGE,
  MOUNT,
  UNMOUNT,
};
